import React from 'react';

import { HeadingProps } from './Heading.types';

import { H1, H2, H3, H4 } from './Heading.styles';

export function Heading({ variant = 'h1', children, ...props }: HeadingProps) {
  switch (variant) {
    case 'h1':
      return <H1 {...props}>{children}</H1>;
    case 'h2':
      return <H2 {...props}>{children}</H2>;
    case 'h3':
      return <H3 {...props}>{children}</H3>;
    case 'h4':
      return <H4 {...props}>{children}</H4>;
  }
}
